import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { AuthenticationReducer } from "../../Core/Services/Authentication/AuthenticationReducer";
import { I18nReducer } from "../../Core/Services/I18n/i18nReducer";
import { WorkersReducer } from "../../Core/Services/Workers/WorkersReducer";

export const rawAppReducer = combineReducers({
  I18n: I18nReducer,
  Authentication: AuthenticationReducer,
  WorkersReducer: WorkersReducer,
});

export const ApplicationReducer = persistReducer(
  {
    key: "back-office-root",
    whitelist: ["Authentication"],
    storage,
  },
  rawAppReducer
);

export type AppState = ReturnType<typeof rawAppReducer>;
